import React, { useEffect, useState } from "react";
import {
  getFormContent,
  getSingleSurvey,
  updateFormContent,
  surveyResultPreview,
  sharePreviewLink,
  addFormContent,
  imageUpload,
} from "../../../api/services/services";
import backArrow from "../../../imgs/BackArrow.svg";
import MainTemplate from "../../templates/MainTemplate";
import { useNavigate } from "react-router-dom";
import { Button, Snackbar, Box } from "@mui/material";
import { Row, Col } from "react-bootstrap";
import MuiAlert from "@mui/material/Alert";
import { Bucket } from "../../../api/config/apiConfig";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import CircularProgress from "@mui/material/CircularProgress";
import Input from "../../atoms/Input";
import removeImg from "../../../imgs/remove.png";
import { useParams } from "react-router-dom";
import generatePDF, { Resolution, Margin } from "react-to-pdf";
import html2pdf from "html2pdf.js";
import ShareWithClientsModal from "../../molecules/ShareWithClients";
import Typography from "@mui/material/Typography";
import ContactDetailField from "../../molecules/ContactDetailField";
import DynamicText from "../../molecules/DynamicText";
import PackingInventoryDownload from "./ClientSide/download";
import PrintComponent from "../PrintComponent";
import editIcn from "../../../imgs/edit.png";
import trashIcn from "../../../imgs/trash.png";
import LoadingModal from "../../molecules/LoadingModal";
import moment from "moment";
import MySignatureCanvas from "../../molecules/signature_canvas";
import { sendSuperAdminVerificationForEdit } from "../PrebidAgreement/creation/service";
import SuperAdminVerifationModal from "../../molecules/SuperAdminVerifationModal";
import PremiumPageLayout from "../../templates/PremiumPageLayout";
import PremiumCard from "../../molecules/PremiumCard";
import SectionHeader from "../../molecules/SectionHeader";
import PersonIcon from "@mui/icons-material/Person";
import InfoIcon from "@mui/icons-material/Info";
import InventoryIcon from "@mui/icons-material/Inventory";
import CommentIcon from "@mui/icons-material/Comment";
import GavelIcon from "@mui/icons-material/Gavel";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import ShareIcon from "@mui/icons-material/Share";
import NoteAltIcon from "@mui/icons-material/NoteAlt";
import DescriptionIcon from "@mui/icons-material/Description";

const PackingInventoryPage = () => {
  const { surveyId, id, flg, org } = useParams();
  const [surveyData, setSurveyData] = useState(null);
  const navigate = useNavigate();

  const [formContentId, setFormContentId] = useState("");
  const [isEdit, setIsEdit] = useState(flg == "1" ? true : false);

  const [isLoading, setIsLoading] = useState(true);
  const [formContent, setFormContent] = useState({
    clientName: "",
    clientEmail: "",
    clientSign: "",
    clientSignDestination: "",
    destContractorSign: "",
    originContractorSign: "",
    originAddress: "",
    destinationAddress: "",
    organization: org,
    fileRef: "",
    vanNo: "",
    date: "",
    dataRows: [
      {
        description: "",
        conditionAtOrigin: "",
        conditionAtDestination: "",
      },
    ],
    remarks: "",
    number1: "",
    number2: "",
    clients: [],
    descriptiveSymbols: {
      professionalBooks: false,
      colorTV: false,
      professionalEquipments: false,
      carrierDis: false,
      professionalPapers: false,
      disByOwner: false,
      carrierPacked: false,
    },
    exceptions: {
      rent: false,
      dented: false,
      rubbed: false,
      broken: false,
      faded: false,
      rusted: false,
      burned: false,
      loose: false,
      badly: false,
      chipped: false,
      marred: false,
    },
  });

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const [isShare, setIsShare] = useState(false);

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const [mediaKeysToSend, setMediaKeysToSend] = useState([]);
  const [mediaKeysToRemove, setMediaKeysToRemove] = useState([]);

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  //
  const getSurveyPreview = () => {
    surveyResultPreview(surveyId)
      .then((response) => {
        setSurveyData(response?.data?.data?.surveyDetail);
        let values = { ...formContent };
        values.originAddress = `${response?.data?.data?.surveyDetail?.loadPlaceStAddress}, ${response?.data?.data?.surveyDetail?.loadPlaceCity}, ${response?.data?.data?.surveyDetail?.loadPlaceCountry}`;
        values.destinationAddress = `${response?.data?.data?.surveyDetail?.unloadPlaceStAddress}, ${response?.data?.data?.surveyDetail?.unloadPlaceCity}, ${response?.data?.data?.surveyDetail?.unloadPlaceCountry}`;
        values.clientName = `${response?.data?.data?.surveyDetail?.name}`;
        values.clientEmail = `${response?.data?.data?.surveyDetail?.email}`;
        values.fileRef = `${response?.data?.data?.surveyDetail?.id}`;

        let dR = [];

        let itemsInd = 0;

        // console.log(response?.data?.data?.surveyDetail?.surveyResult?.surveyRooms)
        response?.data?.data?.surveyDetail?.surveyResult?.surveyRooms?.forEach(
          (rm, ind) => {
            // console.log(rm?.roomItems);
            rm?.roomItems?.forEach((rmIt) => {
              // console.log(itemsInd);
              // console.log(values.dataRows);

              // Adding a new object to the dataRows array
              values.dataRows.push({
                no: ind + 1,
                description: rmIt?.name,
                conditionAtOrigin: "",
                conditionAtDestination: "",
              });
              itemsInd += 1;
            });
          }
        );
        // console.log(values)

        setFormContent(values);

        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = "/login";
        }
      });
  };

  //
  const getSurvey = () => {
    getSingleSurvey(surveyId)
      .then((response) => {
        if (response?.data?.data?.status == "submitted") getSurveyPreview();
        else {
          setSurveyData(response?.data?.data);
          let values = { ...formContent };
          values.originAddress = `${response?.data?.data?.loadPlaceStAddress}, ${response?.data?.data?.loadPlaceCity}, ${response?.data?.data?.loadPlaceCountry}`;
          values.destinationAddress = `${response?.data?.data?.unloadPlaceStAddress}, ${response?.data?.data?.unloadPlaceCity}, ${response?.data?.data?.unloadPlaceCountry}`;
          values.clientName = `${response?.data?.data?.name}`;
          values.clientEmail = `${response?.data?.data?.email}`;
          values.fileRef = `${response?.data?.data?.id}`;
          setFormContent(values);

          setIsLoading(false);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = "/login";
        }
      });
  };

  //
  const addContent = () => {
    setIsLoading(true);
    const body = {
      formId: id,
      surveyId: surveyId,
      content: formContent,
      mediaKeys: mediaKeysToSend,
      removedMediaKeys: [],
    };
    addFormContent(body)
      .then(() => {
        setSnackbarMessage("Packing Inventory has been added successfully!");
        setOpenSnackbar(true);

        setTimeout(() => {
          navigate(-1);
          setIsLoading(false);
        }, 1000);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = "/login";
        }

        setIsLoading(false);
      });
  };

  //
  const updateContent = () => {
    setIsLoading(true);
    const body = {
      formId: id,
      surveyId: surveyId,
      content: formContent,
      mediaKeys: mediaKeysToSend,
      removedMediaKeys: mediaKeysToRemove,
    };
    updateFormContent(body, formContentId)
      .then((res) => {
        setSnackbarMessage("Packing Inventory has been updated successfully!");
        setOpenSnackbar(true);

        getContent();
        setIsEdit(false);

        setIsLoading(false);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = "/login";
        }

        setIsLoading(false);
      });
  };

  //
  const getContent = () => {
    setIsLoading(true);
    getFormContent(id, surveyId)
      .then((res) => {
        setFormContentId(res.data.data.uuid);
        setFormContent(res.data.data.content);
        setIsLoading(false);
        setMediaKeysToSend([]);
        setMediaKeysToRemove([]);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = "/login";
        }

        setIsLoading(false);
        setMediaKeysToSend([]);
        setMediaKeysToRemove([]);
      });
  };

  useEffect(() => {
    // if (flg == "1") getSurvey();
    if (flg == "2") getContent();
  }, []);

  const [show, setShow] = useState(false);
  const options = {
    // resolution: Resolution.HIGH,
    page: {
      // margin is in MM, default is Margin.NONE = 0
      margin: Margin.SMALL,
      // default is 'A4'
      format: "letter",
      // default is 'portrait'
      orientation: "portrait",
    },
    canvas: {
      // default is 'image/jpeg' for better size performance
      mimeType: "image/png",
      qualityRatio: 1,
    },
    overrides: {
      pdf: {
        compress: true,
      },
    },
  };

  //
  const generatePdf = () => {
    if (window.innerWidth <= 768) {
      if (typeof setSnackbarMessage !== "undefined" && typeof setOpenSnackbar !== "undefined") {
        setSnackbarMessage("For a good experience, please use a desktop screen");
        setOpenSnackbar(true);
      } else {
        alert("For a good experience, please use a desktop screen");
      }
      return;
    }

    setShow(true);

    setTimeout(() => {
      const content = document.getElementById("content-to-convert"); // Replace with the ID of the element you want to convert to PDF

      const currentDateTime = new Date();
      const filename = `survey_${currentDateTime.toISOString()}.pdf`;

      const pdfOptions = {
        margin: 5,
        filename: filename,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: {
          unit: "mm",
          format: "a4",
          orientation: "portrait",
        }, // Set the page size here
      };

      let temp = html2pdf().from(content).set(pdfOptions).outputPdf();
      temp.save(filename);

      setShow(false);
    }, 3500);
  };

  const [downloadText, setDownloadText] = useState("download");

  const getTargetElement = () => document.getElementById("content-id");

  //
  const shareWithClient = (data) => {
    let ems = [];
    let emsInd = 0;
    data.map((dt) => {
      if (dt.trim().length != 0) {
        ems[emsInd] = dt;
        emsInd++;
      }
    });

    setIsLoading(true);
    const body = {
      surveyId: surveyId,
      formId: id,
      emails: ems,
      formRoute: "packing-inventory-preview",
    };
    sharePreviewLink(body)
      .then(() => {
        let values = { ...formContent };

        ems?.map((em, ind) => {
          values.clients.push({
            email: em,
            sign: "",
          });
        });
        setSnackbarMessage(
          "Packing Inventory has been shared with the respective emails successfully!"
        );
        setOpenSnackbar(true);

        // updateContent(values);

        setIsLoading(false);
        setIsShare(false);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = "/login";
        }

        setIsLoading(false);
      });
  };

  const handleAddNewDataRows = () => {
    const values = { ...formContent };
    const valuesRows = [...formContent?.dataRows];
    valuesRows.push({
      no: "",
      description: "",
      condition: "",
      disclamer: "",
    });
    values.dataRows = valuesRows;

    setFormContent(values);
  };

  const handleRemoveDataRows = (ind) => {
    const values = { ...formContent };
    const valuesRows = [...formContent?.dataRows];
    valuesRows.splice(ind, 1);
    values.dataRows = valuesRows;

    setFormContent(values);
  };

  const getItemConditionReportData = () => {
    setIsLoading(true);
    getFormContent("19d7db4c-2bdd-492e-8b5f-5e030345fa47", surveyId)
      .then((res) => {
        let values = { ...formContent };
        let valuesdR = [];
        res?.data?.data?.content?.dataRows?.map((dR, ind) => {
          valuesdR[ind] = {
            description: dR.description,
            conditionAtOrigin: dR.condition,
            conditionAtDestination: "",
          };
        });
        values.dataRows = valuesdR;

        surveyResultPreview(surveyId)
          .then((response) => {
            setSurveyData(response?.data?.data?.surveyDetail);

            values.originAddress = `${response?.data?.data?.surveyDetail?.loadPlaceStAddress}, ${response?.data?.data?.surveyDetail?.loadPlaceCity}, ${response?.data?.data?.surveyDetail?.loadPlaceCountry}`;
            values.destinationAddress = `${response?.data?.data?.surveyDetail?.unloadPlaceStAddress}, ${response?.data?.data?.surveyDetail?.unloadPlaceCity}, ${response?.data?.data?.surveyDetail?.unloadPlaceCountry}`;
            values.clientName = `${response?.data?.data?.surveyDetail?.name}`;
            values.clientEmail = `${response?.data?.data?.surveyDetail?.email}`;
            values.fileRef = `${response?.data?.data?.surveyDetail?.id}`;
          })
          .catch((error) => {
            if (error?.response?.data?.statusCode == 401) {
              localStorage.clear();
              window.location.pathname = "/login";
            }
          });

        setFormContent(values);
        setIsLoading(false);
      })
      .catch((error) => {
        // setSnackbarMessage(error?.response?.data?.message);
        // setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = "/login";
        }

        setIsLoading(false);
        getSurvey();
      });
  };

  useEffect(() => {
    if (flg == "1") getItemConditionReportData();
  }, []);


  const [uploadText1, setUploadText1] = useState("Upload Sign");
  const [uploadText2, setUploadText2] = useState("Upload Sign");

  const [isSignCanvas, setSignCanvas] = useState(false);
  const [whichSign, setWhichSign] = useState("");

  //
  const uploadFile = async (file) => {
    setIsLoading(true);

    handleOpen();
    if (whichSign == "destContractor") setUploadText1("Uploading...");
    if (whichSign == "originContractor") setUploadText2("Uploading...");

    const fd = new FormData();
    fd.append("image", file);

    imageUpload(fd)
      .then((res) => {
        let values = { ...formContent };

        let dlt = [...mediaKeysToRemove];

        if (whichSign == "destContractor") {
          if (formContent.destContractorSign?.trim()?.length != 0)
            dlt.push(formContent.destContractorSign);
          values.destContractorSign = res?.data?.data?.key;
        }
        if (whichSign == "originContractor") {
          if (formContent.originContractorSign?.trim()?.length != 0)
            dlt.push(formContent.originContractorSign);
          values.originContractorSign = res?.data?.data?.key;
        }
        setFormContent(values);

        let md = [...mediaKeysToSend];
        md.push(res?.data?.data?.key);
        setMediaKeysToSend(md);

        setMediaKeysToRemove(dlt);

        setUploadText1("Upload Sign");
        setUploadText2("Upload Sign");
        setIsLoading(false);
        handleClose();
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = "/login";
        }

        setUploadText1("Upload Sign");
        setUploadText2("Upload Sign");

        setIsLoading(false);
        handleClose();
      });
  };

  const [isVerified, setIsVerified] = useState(false);
  const [isEditLoading, setIsEditLoading] = useState(false);

  const sendEditRequestToAdmin = () => {
    setIsEditLoading(true);
    sendSuperAdminVerificationForEdit()
      .then((response) => {
        setIsVerified(true);
        setIsEditLoading(false);
      })
      .catch((error) => {
        setIsVerified(false);
        setIsEditLoading(false);
      });
  };
  const printAction = () => {
    // Simply trigger the print dialog. 
    // The table-based layout in PrintComponent handles pagination automatically.
    setTimeout(() => {
      window.print();
    }, 500);
  };

  const pageActions = (
    <>
      {!isEdit && (
        <Button
          variant="contained"
          onClick={() => {
            sendEditRequestToAdmin();
          }}
          disabled={isEditLoading}
          startIcon={<NoteAltIcon />}
           sx={{ 
            textTransform: "none", 
            borderRadius: "var(--radius-md)", 
            padding: "10px 24px",
            fontWeight: 700,
            backgroundColor: "var(--primary-color)",
            boxShadow: "0 4px 12px rgba(79, 70, 229, 0.2)",
            '&:hover': { backgroundColor: 'var(--primary-hover)' }
          }}
        >
          Edit
        </Button>
      )}

      {!isEdit && (
        <Button
          variant="outlined"
          onClick={() => {
            setIsShare(true);
          }}
          disabled={isLoading}
           sx={{ 
            textTransform: "none", 
            borderRadius: "var(--radius-md)", 
            padding: "10px 24px",
            fontWeight: 700,
            border: "1px solid var(--glass-border)",
            color: "var(--text-main)",
            '&:hover': { background: 'var(--bg-color)', borderColor: 'var(--primary-color)' }
          }}
        >
          Share
        </Button>
      )}

      {isEdit && flg === "2" && (
        <Button
          variant="outlined"
          color="error"
          onClick={() => {
            getContent();
            setIsEdit(false);
          }}
          disabled={isLoading}
           sx={{ textTransform: "none", borderRadius: "var(--radius-md)", fontWeight: 700, padding: "10px 24px", border: "1px solid" }}
        >
          Cancel
        </Button>
      )}

      {isEdit && (
        <Button
          variant="contained"
          onClick={() => {
            if (flg === "1") addContent();
            else updateContent();
          }}
          disabled={isLoading}
           sx={{ 
            textTransform: "none", 
            borderRadius: "var(--radius-md)", 
            padding: "10px 32px",
            fontWeight: 700,
            backgroundColor: "var(--primary-color)",
            boxShadow: "0 4px 12px rgba(79, 70, 229, 0.3)",
            '&:hover': { backgroundColor: 'var(--primary-hover)' }
          }}
        >
          Save
        </Button>
      )}

      {!isEdit && (
        <Button
          variant="contained"
          onClick={() => {
            const tempTitle = document.title;
            const newTitle = `Packing-Inventory-${formContent?.clientName || 'Document'}-${moment().format("DD.MM.YYYY")}`;
            document.title = newTitle;
            
            // Call printAction which handles the print
            printAction();
            
            // Restore title after a longer delay to ensure print dialog caught it
            setTimeout(() => {
              document.title = tempTitle;
            }, 2000);
          }}
          disabled={isLoading}
          startIcon={<DescriptionIcon />}
           sx={{ 
            textTransform: "none", 
            borderRadius: "var(--radius-md)", 
            padding: "10px 24px",
            fontWeight: 700,
            backgroundColor: "var(--text-main)",
             boxShadow: "0 4px 12px rgba(15, 23, 42, 0.2)",
             '&:hover': { backgroundColor: '#000' }
          }}
        >
          Save as PDF
        </Button>
      )}
    </>
  );

  return (
    <>
    <div className="no-print">
      <PremiumPageLayout
        title="Packing Inventory"
        actions={pageActions}
        onBack={() => navigate(-1)}
      >
        <SectionHeader title="General Information" icon={<PersonIcon />} />
        <PremiumCard sx={{ marginBottom: "32px", padding: "24px" }}>

          {/* file detail*/}
          <div className="contact-detail d-flex mt-4">
            {/* left col */}
            <div
              className={`left-col ${
                !isEdit ? " w-50" : "w-50 pe-5"
              } text-start`}
            >
              <Typography variant="body1" gutterBottom>
                <ContactDetailField
                  label="Client Name"
                  isEdit={isEdit}
                  type="text"
                  minWidth={"160px"}
                  value={formContent?.clientName}
                  onChange={(e) => {
                    let values = { ...formContent };
                    values.clientName = e.target.value;
                    setFormContent(values);
                  }}
                  disabled
                />
                <ContactDetailField
                  label="Origin Address"
                  isEdit={isEdit}
                  type="text"
                  minWidth={"160px"}
                  value={formContent?.originAddress}
                  onChange={(e) => {
                    let values = { ...formContent };
                    values.originAddress = e.target.value;
                    setFormContent(values);
                  }}
                />
                <ContactDetailField
                  label="Destination Address"
                  isEdit={isEdit}
                  type="text"
                  minWidth={"160px"}
                  value={formContent?.destinationAddress}
                  onChange={(e) => {
                    let values = { ...formContent };
                    values.destinationAddress = e.target.value;
                    setFormContent(values);
                  }}
                />

                <ContactDetailField
                  label="Organization"
                  isEdit={isEdit}
                  type="text"
                  minWidth={"160px"}
                  value={formContent?.organization}
                  onChange={(e) => {
                    let values = { ...formContent };
                    values.organization = e.target.value;
                    setFormContent(values);
                  }}
                />
              </Typography>
            </div>
            {/* right col */}
            <div
              className={`right-col ${
                !isEdit ? "w-50" : "w-50 ps-5"
              }  d-flex flex-column align-items-end pe-2`}
            >
              <div
                className=""
                style={isEdit ? { width: "-webkit-fill-available" } : {}}
              >
                <Typography
                  variant="body1"
                  className="text-start w-100"
                  gutterBottom
                >
                  <ContactDetailField
                    label="File Ref"
                    isEdit={isEdit}
                    type="text"
                    minWidth={"120px"}
                    value={formContent?.fileRef}
                    onChange={(e) => {
                      let values = { ...formContent };
                      values.fileRef = e.target.value;
                      setFormContent(values);
                    }}
                    disabled
                  />

                  <ContactDetailField
                    label="Van No. "
                    isEdit={isEdit}
                    type="text"
                    wrapperStyle="justify-content-start"
                    minWidth={"120px"}
                    value={formContent?.vanNo}
                    onChange={(e) => {
                      let values = { ...formContent };
                      values.vanNo = e.target.value;
                      setFormContent(values);
                    }}
                  />
                  <ContactDetailField
                    label="Date"
                    isEdit={isEdit}
                    type="date"
                    wrapperStyle="justify-content-start"
                    minWidth={"120px"}
                    value={formContent?.date}
                    onChange={(e) => {
                      let values = { ...formContent };
                      values.date = e.target.value;
                      setFormContent(values);
                    }}
                  />
                </Typography>
              </div>
            </div>
          </div>
          {/* /file detail */}
           </PremiumCard>

           <SectionHeader title="Descriptive & Exception Symbols" icon={<InfoIcon />} />
           <PremiumCard sx={{ marginBottom: "32px", padding: "24px" }}>
          {/* Symbols */}
          <Row className="mx-0 mt-3">
            {" "}
            <Col className="col-12 col-md-5  text-start ps-0 mb-1">
              <h5>DESCRIPTIVE SYMBOLS</h5>
            </Col>
            <Col className="col-12 col-md-5  text-start ps-0 mb-1">
              <h5>EXCEPTION SYMBOLS</h5>
            </Col>
          </Row>
          <Row className="mx-0">
            <Col className="col-12 col-md-5  ">
              <div className="p-3 row  bg-white me-3">
                <div className="col-6 px-2">
                  <div
                    className={`p-2 px-0 d-flex justify-content-center  mb-3  ${
                      formContent?.descriptiveSymbols?.professionalBooks
                        ? "symbols-active"
                        : "symbols-inactive"
                    }`}
                    onClick={() => {
                      let values = { ...formContent };
                      values.descriptiveSymbols.professionalBooks =
                        !values.descriptiveSymbols.professionalBooks;
                      setFormContent(values);
                    }}
                  >
                    {" "}
                    PB - PROFESSIONAL BOOKS
                  </div>
                </div>
                {/*  */}
                <div className="col-6 px-2">
                  <div
                    className={`p-2 px-0 d-flex justify-content-center  mb-3  ${
                      formContent?.descriptiveSymbols?.colorTV
                        ? "symbols-active"
                        : "symbols-inactive"
                    }`}
                    onClick={() => {
                      let values = { ...formContent };
                      values.descriptiveSymbols.colorTV =
                        !values.descriptiveSymbols.colorTV;
                      setFormContent(values);
                    }}
                  >
                    {" "}
                    C/T - COLOR TV
                  </div>
                </div>

                {/*  */}
                <div className="col-6 px-2">
                  <div
                    className={`p-2 px-0 d-flex justify-content-center  mb-3  ${
                      formContent?.descriptiveSymbols?.professionalEquipments
                        ? "symbols-active"
                        : "symbols-inactive"
                    }`}
                    onClick={() => {
                      let values = { ...formContent };
                      values.descriptiveSymbols.professionalEquipments =
                        !values.descriptiveSymbols.professionalEquipments;
                      setFormContent(values);
                    }}
                  >
                    {" "}
                    PE - PROFESSIONAL EQUIPMENTS
                  </div>
                </div>

                {/*  */}
                <div className="col-6 px-2">
                  <div
                    className={`p-2 px-0 d-flex justify-content-center  mb-3  ${
                      formContent?.descriptiveSymbols?.carrierDis
                        ? "symbols-active"
                        : "symbols-inactive"
                    }`}
                    onClick={() => {
                      let values = { ...formContent };
                      values.descriptiveSymbols.carrierDis =
                        !values.descriptiveSymbols.carrierDis;
                      setFormContent(values);
                    }}
                  >
                    {" "}
                    CD - CARRIER DISASSEMBLED
                  </div>
                </div>

                {/*  */}

                <div className="col-6 px-2">
                  <div
                    className={`p-2 px-0 d-flex justify-content-center  mb-3 ${
                      formContent?.descriptiveSymbols?.professionalPapers
                        ? "symbols-active"
                        : "symbols-inactive"
                    }`}
                    onClick={() => {
                      let values = { ...formContent };
                      values.descriptiveSymbols.professionalPapers =
                        !values.descriptiveSymbols.professionalPapers;
                      setFormContent(values);
                    }}
                  >
                    {" "}
                    PP - PROFESSIONAL PAPERS
                  </div>
                </div>

                {/*  */}

                <div className="col-6 px-2">
                  <div
                    className={`p-2 px-0 d-flex justify-content-center  mb-3  ${
                      formContent?.descriptiveSymbols?.disByOwner
                        ? "symbols-active"
                        : "symbols-inactive"
                    }`}
                    onClick={() => {
                      let values = { ...formContent };
                      values.descriptiveSymbols.disByOwner =
                        !values.descriptiveSymbols.disByOwner;
                      setFormContent(values);
                    }}
                  >
                    {" "}
                    DBO - DISASSEMBLED BY OWNER
                  </div>
                </div>

                {/*  */}
                <div className="col-6 px-2">
                  <div
                    className={`p-2 px-0 d-flex justify-content-center  mb-0 ${
                      formContent?.descriptiveSymbols?.carrierPacked
                        ? "symbols-active"
                        : "symbols-inactive"
                    }`}
                    onClick={() => {
                      let values = { ...formContent };
                      values.descriptiveSymbols.carrierPacked =
                        !values.descriptiveSymbols.carrierPacked;
                      setFormContent(values);
                    }}
                  >
                    {" "}
                    CP - CARRIER PACKED
                  </div>
                </div>

                {/*  */}
              </div>
            </Col>
            <Col className="col-12 col-md-7 ">
              <div className="p-3 row  bg-white ">
                {/*  */}
                <div className="col-4 px-2">
                  <div
                    className={`p-2 px-0 d-flex justify-content-center  mb-3  ${
                      formContent?.exceptions?.rent
                        ? "symbols-active"
                        : "symbols-inactive"
                    }`}
                    onClick={() => {
                      let values = { ...formContent };
                      values.exceptions.rent = !values.exceptions?.rent;
                      setFormContent(values);
                    }}
                  >
                    {" "}
                    RE- RENT
                  </div>
                </div>

                {/*  */}
                <div className="col-4 px-2">
                  <div
                    className={`p-2 px-0 d-flex justify-content-center mb-3  ${
                      formContent?.exceptions?.dented
                        ? "symbols-active"
                        : "symbols-inactive"
                    }`}
                    onClick={() => {
                      let values = { ...formContent };
                      values.exceptions.dented = !values.exceptions?.dented;
                      setFormContent(values);
                    }}
                  >
                    {" "}
                    D- DENTED
                  </div>
                </div>

                {/*  */}
                <div className="col-4 px-2">
                  <div
                    className={`p-2 px-0 d-flex justify-content-center mb-3  ${
                      formContent?.exceptions?.rubbed
                        ? "symbols-active"
                        : "symbols-inactive"
                    }`}
                    onClick={() => {
                      let values = { ...formContent };
                      values.exceptions.rubbed = !values.exceptions?.rubbed;
                      setFormContent(values);
                    }}
                  >
                    {" "}
                    R- RUBBED
                  </div>
                </div>

                {/*  */}
                <div className="col-4 px-2">
                  <div
                    className={`p-2 px-0 d-flex justify-content-center mb-3  ${
                      formContent?.exceptions?.broken
                        ? "symbols-active"
                        : "symbols-inactive"
                    }`}
                    onClick={() => {
                      let values = { ...formContent };
                      values.exceptions.broken = !values.exceptions?.broken;
                      setFormContent(values);
                    }}
                  >
                    {" "}
                    BR-BROKEN
                  </div>
                </div>

                {/*  */}

                <div className="col-4 px-2">
                  <div
                    className={`p-2 px-0 d-flex justify-content-center mb-3  ${
                      formContent?.exceptions?.faded
                        ? "symbols-active"
                        : "symbols-inactive"
                    }`}
                    onClick={() => {
                      let values = { ...formContent };
                      values.exceptions.faded = !values.exceptions?.faded;
                      setFormContent(values);
                    }}
                  >
                    {" "}
                    F-FADED
                  </div>
                </div>

                {/*  */}
                <div className="col-4 px-2">
                  <div
                    className={`p-2 px-0 d-flex justify-content-center mb-3  ${
                      formContent?.exceptions?.rusted
                        ? "symbols-active"
                        : "symbols-inactive"
                    }`}
                    onClick={() => {
                      let values = { ...formContent };
                      values.exceptions.rusted = !values.exceptions?.rusted;
                      setFormContent(values);
                    }}
                  >
                    {" "}
                    RU-RUSTED
                  </div>
                </div>

                {/*  */}
                <div className="col-4 px-2">
                  <div
                    className={`p-2 px-0 d-flex justify-content-center mb-3  ${
                      formContent?.exceptions?.burned
                        ? "symbols-active"
                        : "symbols-inactive"
                    }`}
                    onClick={() => {
                      let values = { ...formContent };
                      values.exceptions.burned = !values.exceptions?.burned;
                      setFormContent(values);
                    }}
                  >
                    {" "}
                    BU-BURNED
                  </div>
                </div>

                {/*  */}
                {/*  */}
                <div className="col-4 px-2">
                  <div
                    className={`p-2 px-0 d-flex justify-content-center mb-3  ${
                      formContent?.exceptions?.loose
                        ? "symbols-active"
                        : "symbols-inactive"
                    }`}
                    onClick={() => {
                      let values = { ...formContent };
                      values.exceptions.loose = !values.exceptions?.loose;
                      setFormContent(values);
                    }}
                  >
                    {" "}
                    L-LOOSE
                  </div>
                </div>

                {/*  */}
                <div className="col-4 px-2">
                  <div
                    className={`p-2 px-0 d-flex justify-content-center mb-3  ${
                      formContent?.exceptions?.badly
                        ? "symbols-active"
                        : "symbols-inactive"
                    }`}
                    onClick={() => {
                      let values = { ...formContent };
                      values.exceptions.badly = !values.exceptions?.badly;
                      setFormContent(values);
                    }}
                  >
                    {" "}
                    W-BADLY
                  </div>
                </div>

                {/*  */}
                <div className="col-4 px-2">
                  <div
                    className={`p-2 px-0 d-flex justify-content-center ${
                      formContent?.exceptions?.chipped
                        ? "symbols-active"
                        : "symbols-inactive"
                    }`}
                    onClick={() => {
                      let values = { ...formContent };
                      values.exceptions.chipped = !values.exceptions?.chipped;
                      setFormContent(values);
                    }}
                  >
                    {" "}
                    CH-CHIPPED
                  </div>
                </div>

                {/*  */}
                <div className="col-4 px-2">
                  <div
                    className={`p-2 px-0 d-flex justify-content-center   ${
                      formContent?.exceptions?.marred
                        ? "symbols-active"
                        : "symbols-inactive"
                    }`}
                    onClick={() => {
                      let values = { ...formContent };
                      values.exceptions.marred = !values.exceptions?.marred;
                      setFormContent(values);
                    }}
                  >
                    {" "}
                    M-MARRED
                  </div>
                </div>

                {/*  */}
              </div>
            </Col>
          </Row>
          </PremiumCard>

          <SectionHeader title="Inventory Items" icon={<InventoryIcon />} />
           <PremiumCard sx={{ marginBottom: "32px", padding: "24px" }}>
          {/* Table */}
          <Grid container className="pe-1 my-4 ">
            <TableContainer component={Paper} className="pb-3">
              <Table>
                {/* Table Header */}
                <TableHead>
                  <TableRow>
                    <TableCell className="table-head min-w-100">
                      Item No.
                    </TableCell>
                    <TableCell className="table-head min-w-400">
                      Goods Description
                    </TableCell>
                    <TableCell className="table-head min-w-100">
                      Condition at Origin
                    </TableCell>
                    <TableCell className="table-head min-w-150">
                      Condition at Destination
                    </TableCell>
                    {isEdit && (
                      <TableCell className="table-head min-w-25"></TableCell>
                    )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {formContent?.dataRows?.length > 0 ? (
                    <>
                      {formContent?.dataRows.map((row, index) => (
                        <TableRow key={index}>
                          <TableCell> {index + 1}</TableCell>
                          <TableCell>
                            {isEdit ? (
                              <>
                                {/* <TextArea
                              rows="2"
                              label="Description..."
                              id="description"
                              value={row?.description}
                              onChange={(e) => {
                                const values = { ...formContent };
                                const valuesRows = [...formContent?.dataRows];
                                valuesRows.description = e.target.value;
                                values.dataRows = valuesRows;
                                setFormContent(values);
                              }}
                            /> */}

                                <Input
                                  id="condition"
                                  label="Description..."
                                  type="text"
                                  style="full-border-field"
                                  value={row?.description}
                                  onChange={(e) => {
                                    const values = { ...formContent };
                                    const valuesRows = [
                                      ...formContent?.dataRows,
                                    ];
                                    valuesRows[index].description =
                                      e.target.value;
                                    values.dataRows = valuesRows;
                                    setFormContent(values);
                                  }}
                                  inline={{ width: "-webkit-fill-available" }}
                                />
                              </>
                            ) : row?.description ? (
                              row?.description
                            ) : (
                              "-"
                            )}
                          </TableCell>
                          <TableCell>
                            {isEdit ? (
                              <Input
                                id="condition"
                                label="Condition at origin..."
                                type="text"
                                style="full-border-field"
                                value={row?.conditionAtOrigin}
                                onChange={(e) => {
                                  const values = { ...formContent };
                                  const valuesRows = [...formContent?.dataRows];
                                  valuesRows[index].conditionAtOrigin =
                                    e.target.value;
                                  values.dataRows = valuesRows;
                                  setFormContent(values);
                                }}
                                inline={{ width: "-webkit-fill-available" }}
                              />
                            ) : row?.conditionAtOrigin ? (
                              row?.conditionAtOrigin
                            ) : (
                              "-"
                            )}
                          </TableCell>
                          <TableCell>
                            {isEdit ? (
                              <Input
                                id="disclamer"
                                label="Condition at destination..."
                                type="text"
                                style="full-border-field"
                                value={row?.conditionAtDestination}
                                onChange={(e) => {
                                  const values = { ...formContent };
                                  const valuesRows = [...formContent?.dataRows];
                                  valuesRows[index].conditionAtDestination =
                                    e.target.value;
                                  values.dataRows = valuesRows;
                                  setFormContent(values);
                                }}
                                inline={{ width: "-webkit-fill-available" }}
                              />
                            ) : row?.conditionAtDestination ? (
                              row?.conditionAtDestination
                            ) : (
                              "-"
                            )}
                          </TableCell>
                          {isEdit && (
                            <TableCell>
                              <img
                                src={removeImg}
                                height={18}
                                width={18}
                                className="cursor-pointer"
                                onClick={() => handleRemoveDataRows(index)}
                              />
                            </TableCell>
                          )}
                        </TableRow>
                      ))}
                    </>
                  ) : (
                    <TableRow className="text-center">
                      <TableCell colSpan={6}>
                        {isLoading ? (
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              margin: "10px 0px",
                            }}
                          >
                            <CircularProgress
                              style={{
                                color: "#00aff0",
                                height: "25px",
                                width: "25px",
                              }}
                            />
                          </Box>
                        ) : (
                          <div className="d-flex justify-content-center">
                            <p className="my-3">No Records to Show</p>
                          </div>
                        )}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>

          <Row className="mb-5">
            <Col className="col-12 text-end">
              {isEdit && (
                <Button
                  className="add-new-btn ms-auto"
                  onClick={() => {
                    handleAddNewDataRows();
                  }}
                  disabled={isLoading}
                >
                  Add New
                </Button>
              )}
            </Col>
          </Row>
          </PremiumCard>

          <SectionHeader title="Remarks & Acknowledgment" icon={<CommentIcon />} />
           <PremiumCard sx={{ marginBottom: "32px", padding: "24px" }}>
          {/* Remarks */}
          <div className="mt-5 pe-1">
            <Typography variant="body1" className="text-start" gutterBottom>
              <DynamicText
                label="Remarks:"
                textAreaLabel="Remarks..."
                isEdit={isEdit}
                value={formContent?.remarks}
                onChange={(e) => {
                  let values = { ...formContent };
                  values.remarks = e.target.value;
                  setFormContent(values);
                }}
              />
            </Typography>
          </div>
          {/* /Remakes */}

          <div className="mt-5 pe-1 d-flex justify-content-start flex-wrap align-items-baseline mb-5">
            <div>
              <p className="mb-2">
                WE HAVE CHECKED ALL THE ITEM LISTED AND NUMBERED
              </p>
            </div>
            {isEdit ? (
              <input
                type={"text"}
                // className={`${style || "input-field "}`}
                className={`mx-3 input-field`}
                // placeholder={label}
                value={formContent?.number1}
                onChange={(e) => {
                  let values = { ...formContent };
                  values.number1 = e.target.value;
                  setFormContent(values);
                }}
                style={{ width: "300px" }}
              />
            ) : (
              <div>
                <p className="mb-2 mx-2 text-decoration-underline">
                  <b>{formContent?.number1}</b>
                </p>
              </div>
            )}
            <div>
              <p className="mb-2">to</p>
            </div>
            {isEdit ? (
              <input
                type={"text"}
                // className={`${style || "input-field "}`}
                className={`mx-3 input-field`}
                // placeholder={label}
                value={formContent?.number2}
                onChange={(e) => {
                  let values = { ...formContent };
                  values.number2 = e.target.value;
                  setFormContent(values);
                }}
                style={{ width: "300px" }}
              />
            ) : (
              <div>
                <p className="mb-2 mx-2 text-decoration-underline">
                  <b>{formContent?.number2}</b>
                </p>
              </div>
            )}
            <div>
              <p className="mb-2 ">
                INCLUSIVE AND ACKNOWLEDGE THAT THIS IS A TRUE AND COMPLETE LIST
                OF THE GOODS.
              </p>
            </div>
          </div>
          </PremiumCard>

          <SectionHeader title="Approvals" icon={<GavelIcon />} />
           <PremiumCard sx={{ marginBottom: "32px", padding: "24px" }}>
          <Row className="mt-5 pt-5 no-print">
            <Col sm={6} className="mt-5 pt-5">
              <div
                style={{ height: "90px" }}
                className="d-flex justify-content-center align-items-end"
              >
                {formContent?.destContractorSign?.trim()?.length == 0 ? (
                  <>
                    {isEdit && (
                      <div className="d-flex justify-content-center align-items-end">
                        <label
                          htmlFor="uploadSign2"
                          className="active-btn ms-2 w-200 d-flex align-items-center justify-content-center cursor-pointer btn"
                        >
                          {uploadText1}
                        </label>
                        <input
                          type="button"
                          hidden
                          id="uploadSign2"
                          name="uploadSign2"
                          onClick={() => {
                            setWhichSign("destContractor");
                            setSignCanvas(true);
                          }}
                        />
                      </div>
                    )}
                  </>
                ) : (
                  <div className="d-flex align-items-start">
                    <img
                      src={`${Bucket}${formContent.destContractorSign}`}
                      height={80}
                      width={200}
                    />
                    {isEdit && (
                      <>
                        <label
                          htmlFor="editSign"
                          className=" ms-2  d-flex align-items-center justify-content-center cursor-pointer btn p-0"
                        >
                          <img
                            src={editIcn}
                            height={18}
                            width={18}
                            className="ms-2 cursor-pointer"
                          />
                        </label>
                        <input
                          type="button"
                          hidden
                          id="editSign"
                          name="uploadSign"
                          onClick={() => {
                            setWhichSign("destContractor");
                            setSignCanvas(true);
                          }}
                        />
                        <img
                          src={trashIcn}
                          height={18}
                          width={18}
                          className="ms-2 cursor-pointer"
                          onClick={() => {
                            let keysToDelete = [...mediaKeysToRemove];
                            keysToDelete.push(formContent.destContractorSign);
                            setMediaKeysToRemove(keysToDelete);

                            let values = { ...formContent };
                            values.destContractorSign = "";
                            setFormContent(values);
                          }}
                        />
                      </>
                    )}
                  </div>
                )}
              </div>
              <p>{"_______________________________"}</p>
              <p className="my-1">
                <b>{"Contractor Carrier OR Authorized Agent at DESTINATION"}</b>
              </p>

              {""}
            </Col>
            <Col sm={6} className="mt-5 pt-5">
              <div
                style={{ height: "90px" }}
                className="d-flex justify-content-center align-items-end"
              >
                {formContent?.originContractorSign?.trim()?.length == 0 ? (
                  <>
                    {isEdit && (
                      <div className="d-flex justify-content-center align-items-end">
                        <label
                          htmlFor="uploadSign"
                          className="active-btn ms-2 w-200 d-flex align-items-center justify-content-center cursor-pointer btn"
                        >
                          {uploadText2}
                        </label>
                        <input
                          type="button"
                          hidden
                          id="uploadSign"
                          name="uploadSign"
                          onClick={() => {
                            setWhichSign("originContractor");
                            setSignCanvas(true);
                          }}
                        />
                      </div>
                    )}
                  </>
                ) : (
                  <div className="d-flex align-items-start">
                    <img
                      src={`${Bucket}${formContent?.originContractorSign}`}
                      height={80}
                      width={200}
                    />
                    {isEdit && (
                      <>
                        <label
                          htmlFor="editSign1"
                          className=" ms-2  d-flex align-items-center justify-content-center cursor-pointer btn p-0"
                        >
                          <img
                            src={editIcn}
                            height={18}
                            width={18}
                            className="ms-2 cursor-pointer"
                          />
                        </label>
                        <input
                          type="button"
                          hidden
                          id="editSign1"
                          name="uploadSign"
                          onClick={() => {
                            setWhichSign("originContractor");
                            setSignCanvas(true);
                          }}
                        />
                        <img
                          src={trashIcn}
                          height={18}
                          width={18}
                          className="ms-2 cursor-pointer"
                          onClick={() => {
                            let keysToDelete = [...mediaKeysToRemove];
                            keysToDelete.push(formContent.originContractorSign);
                            setMediaKeysToRemove(keysToDelete);

                            let values = { ...formContent };
                            values.originContractorSign = "";
                            setFormContent(values);
                          }}
                        />
                      </>
                    )}
                  </div>
                )}
              </div>

              <p>{"_______________________________"}</p>
              <p className="my-1">
                <b>{"Contractor Carrier OR Authorized Agent at ORIGIN"}</b>
              </p>

              {""}
            </Col>

            <Col sm={6} className="mt-5 pt-5">
              <div
                style={{ height: "90px" }}
                className="d-flex justify-content-center align-items-end"
              >
                {formContent.clientSignDestination?.trim()?.length != 0 && (
                  <img
                    src={`${Bucket}${formContent.clientSignDestination}`}
                    height={80}
                    width={200}
                  />
                )}
              </div>
              <p>{"_______________________________"}</p>
              <p className="mt-1 mb-1">
                <b>{"Client OR Authorized Person at DESTINATION"}</b>
              </p>

              {""}
            </Col>

            <Col sm={6} className="mt-5 pt-5">
              <div
                style={{ height: "90px" }}
                className="d-flex justify-content-center align-items-end"
              >
                {formContent.clientSign?.trim()?.length != 0 && (
                  <img
                    src={`${Bucket}${formContent.clientSign}`}
                    height={80}
                    width={200}
                  />
                )}
              </div>
              <p>{"_______________________________"}</p>
              <p className="mt-1 mb-1">
                <b>{"Client OR Authorized Person at ORIGIN"}</b>
              </p>

              {""}
            </Col>
          </Row>
          </PremiumCard>

          <Snackbar
            open={openSnackbar}
            autoHideDuration={6000} // Adjust the duration as needed
            onClose={handleCloseSnackbar}
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
          >
            <MuiAlert
              elevation={6}
              variant="filled"
              severity={
                snackbarMessage?.includes("successful") ? "success" : "error"
              }
              onClose={handleCloseSnackbar}
            >
              {snackbarMessage}
            </MuiAlert>
          </Snackbar>

          {/* share with client */}
          {isShare && (
            <ShareWithClientsModal
              open={isShare}
              onClose={() => {
                setIsShare(false);
              }}
              onSuccess={(emails) => {
                shareWithClient(emails);
              }}
            />
          )}
        {/* Add signature Modal */}
        {isSignCanvas && (
          <MySignatureCanvas
            open={isSignCanvas}
            onClose={() => {
              setSignCanvas(false);
            }}
            onSuccess={(file) => {
              if (!isLoading) uploadFile(file);
            }}
          />
        )}

        {isVerified && (
          <SuperAdminVerifationModal
            open={isVerified}
            onClose={() => {
              setIsVerified(false);
            }}
            onSuccess={() => {
              setIsEdit(true);
              setIsVerified(false);
            }}
            onError={() => {
              // shareWithClient(emails);
              setSnackbarMessage("Invalid Confirm Pin");
              setOpenSnackbar(true);
            }}
          />
        )}
      </PremiumPageLayout>
    </div>

      <PrintComponent>
        <PackingInventoryDownload
          id="content-id"
          surveyData={surveyData}
          formContent={formContent}
        />
      </PrintComponent>
    </>
  );
};
export default PackingInventoryPage;
